import React, { Component } from "react";
import { Button, ControlGroup, FormGroup, HTMLSelect, InputGroup, Intent } from "@blueprintjs/core";
import config from "../config";
import ControlledModal from "../controlled_modal";

class AddPaymentModal extends Component {
  state = {
    currency: "EUR",
    amount: "",
    description: "",
  };

  addPayment = () => {
    let amount = null;
    try {
      amount = parseFloat(this.state.amount);
    } catch (e) {}

    if (!amount) {
      alert(`Invalid amount - ${this.state.amount}`);
      return false;
    }

    this.setState({
      currency: "EUR",
      amount: "",
      description: "",
    });

    this.props.onAdd(amount, this.state.currency, this.state.description);

    return true;
  };

  render() {
    return (
      <ControlledModal
        button={<Button small>Add</Button>}
        title="Add new payment"
        okButton={<Button intent={Intent.PRIMARY}>Add payment</Button>}
        okAction={this.addPayment}
      >
        <p>
          <FormGroup label="Payment amount" labelFor="amount-input" labelInfo="(required)">
            <ControlGroup fill vertical={false}>
              <InputGroup
                id="amount-input"
                placeholder="Amount"
                value={this.state.amount}
                onChange={(e) => {
                  this.setState({ amount: e.target.value });
                }}
              />
              <HTMLSelect
                options={config.currencies}
                value={this.state.currency}
                onChange={(e) => {
                  this.setState({
                    currency: e.target.value,
                  });
                }}
              />
            </ControlGroup>
          </FormGroup>
        </p>
        <p>
          <FormGroup label="Payment description" labelFor="description-input">
            <InputGroup
              id="description-input"
              placeholder="Description"
              value={this.state.description}
              onChange={(e) => {
                this.setState({ description: e.target.value });
              }}
            />
          </FormGroup>
        </p>
      </ControlledModal>
    );
  }
}

AddPaymentModal.defaultProps = {
  onAdd: null,
};

export default AddPaymentModal;
